export const commercialCarePage = {
  hero: {
    eyebrow: 'Commercial properties & homeowners associations',
    title: 'Care for the grounds your property depends on.',
    intro:
      'Keep business properties and shared community landscapes looking cared for through the growing season. D.A. Alexander provides lawn and landscape maintenance for commercial properties and homeowners associations.',
    primary: { label: 'Discuss your property care', href: '/contact' },
    image: 'https://codex.websiteforge.net/da-alexander-redesign-20261028/assets/service-care-commercial-20261103.png',
    alt: 'Maintained lawn, planting beds and shade trees outside a brick-and-glass office building.',
  },
  audience: {
    title: 'A cared-for landscape is part of your property.',
    text: 'From entrances and lawn areas to planting beds and shared outdoor space, regular upkeep helps a commercial property or HOA community feel well maintained. Bring routine grounds work and seasonal lawn needs into one property-care conversation.',
    labels: ['Commercial properties', 'HOA common areas', 'Shared community landscapes'],
  },
  services: {
    title: 'Everyday upkeep. Seasonal attention.',
    groups: [
      {
        id: 'routine-landscape-care',
        title: 'Routine landscape care',
        items: ['Lawn mowing, trimming & edging', 'Landscape bed care', 'Tree & shrub pruning'],
      },
      {
        id: 'seasonal-upkeep',
        title: 'Seasonal upkeep',
        items: ['Spring & fall cleanup', 'Annual & perennial flower care'],
      },
      {
        id: 'lawn-programs',
        title: 'Lawn programs',
        items: ['Fertilization & weed control', 'Grub prevention', 'Core aeration'],
      },
    ],
    note: 'Tell us about the grounds you manage and the maintenance or lawn-program services you need.',
  },
  seasonal: {
    title: 'Plan beyond the growing season.',
    text: 'Commercial and HOA property care continues when the weather changes. Explore snow removal and salting, along with commercial parking-lot and site services.',
    link: { label: 'Commercial & seasonal services', href: '/commercial-seasonal-services' },
  },
  closing: {
    title: 'Let’s talk about the property you manage.',
    text: 'Share the location, property type and services you are looking for. We’ll help you find the right starting point for your grounds.',
    action: { label: 'Send a property-care inquiry', href: '/contact' },
    location: 'Based in Livonia. Serving southeast Michigan.',
  },
};
